export default __webpack_public_path__ + "static/media/bar_graph_sample_agent.f900428c.png";